export default __webpack_public_path__ + "static/media/metodologiaPNG.eba99591.png";